/**Перечисление для описания шагов обрезки фото */
enum CropStepEnum {
  /**Начальный этап */
  Default = 'default',
  /**Обрезка изображения */
  Edit = 'edit',
  /**Подтверждение редактирорвания */
  Confirm = 'confirm',
}
export { CropStepEnum }
